import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homesix-courses',
  templateUrl: './homesix-courses.component.html',
  styleUrls: ['./homesix-courses.component.scss']
})
export class HomesixCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
